import React from 'react';
import {BaseMixin, ElementaryMixin, SectionMixin, CcrWriterMixin, Tools} from '../common/common.js';
//import {FloatMixin} from '../layout/layout.js';
import {Backdrop} from './bricks.js';

import './popover.less';

export const Popover = React.createClass({

  //@@viewOn:mixins
  mixins: [
    BaseMixin,
    ElementaryMixin,
    SectionMixin,
    CcrWriterMixin,
    //FloatMixin
  ],
  //@@viewOff:mixins

  //@@viewOn:statics
  statics: {
    tagName: 'UU5.Bricks.ContextMenu',
    classNames: {
      main: 'uu5-bricks-popover',
      open: 'uu5-bricks-popover-shown',
      content: 'uu5-bricks-popover-content',
      header: 'uu5-bricks-popover-header',
      body: 'uu5-bricks-popover-body',
      footer: 'uu5-bricks-popover-footer'
    },
    defaults: {
      transitionDuration: 100
    }
  },
  //@@viewOff:statics

  //@@viewOn:propTypes
  propTypes: {
    shown: React.PropTypes.bool
  },
  //@@viewOff:propTypes

  //@@viewOn:getDefaultProps
  getDefaultProps() {
    return {
      shown: false
    };
  },

  getInitialState() {
    return {
      header: null,
      content: null,
      footer: null,
      pageX: null,
      pageY: null
    };
  },
  //@@viewOff:getDefaultProps

  //@@viewOn:standardComponentLifeCycle
  componentWillMount() {
    this.setState({hidden: !this.props.shown});
  },

  componentWillReceiveProps(nextProps){
    if (nextProps.controlled) {
      this.setState({hidden: !nextProps.shown});
    }
  },
  //@@viewOff:standardComponentLifeCycle

  //@@viewOn:interface
  open(opt, setStateCallback) {
    let pageX = opt.pageX;
    let pageY = opt.pageY;

    if (opt.event) {
      pageX = pageX || opt.event.pageX;
      pageY = pageY || opt.event.pageY;
    }


    this.setState({
      header: opt.header || this.getHeader(),
      content: opt.content || this.getChildren(),
      footer: opt.footer || this.getFooter(),
      hidden: true,
      pageX: 0,
      pageY: 0
    }, ()=> {
      if(window.innerHeight < (pageY + Tools.getOuterHeight(this, true))){
        pageY = pageY - Tools.getOuterHeight(this, true);
      }

      if (window.innerWidth < (pageX + Tools.getOuterWidth(this, true))) {
        pageX = pageX - Tools.getOuterWidth(this, true);
      }
      this.setState({
        hidden: false,
        pageX: pageX,
        pageY: pageY
      }, () => {
        typeof setStateCallback === 'function' && setStateCallback();
      });
    });
    return this;
  },

  close(setStateCallback) {
    this.setState({
      // header: null,
      // content: null,
      // footer: null,
      hidden: true
    }, setStateCallback);

    return this;
  },
  //@@viewOff:interface

  //@@viewOn:overridingMethods
  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers
  _getMainAttrs() {
    let props = this.getMainAttrs();

    !this.isHidden() && (props.className += ' ' + this.getClassName().open);

    props.style = {};
    if (this.state.pageX !== null) {
      props.style = {
        left: this.state.pageX,
        top: this.state.pageY
      };
    }

    //opera mini dont know how to use transitions :(
    if (navigator.userAgent.indexOf('Opera Mini') == -1) {
      let time = this.getDefault().transitionDuration / 1000;
      ['WebkitTransitionDuration', 'MozTransitionDuration', 'MsTransitionDuration',
        'OTransitionDuration', 'transitionDuration'].forEach((style) => {
        //props.style[style] = time + 's';
      });
    }

    return props;
  },

  _getBackdropProps() {
    let backdropId = this.getId() + '-backdrop';

    return {
      hidden: this.isHidden(),
      id: backdropId,
      onClick: (backdrop, event) => {
        event.target.id === backdropId && this.close();
      }
    };
  },

  _getHeader(){
    let header = this.state.header || this.getHeader();
    if (header) {
      header = <div className={this.getClassName().header}>{header}</div>;
    }
    return header;
  },

  _getFooter(){
    let footer = this.state.footer || this.getFooter();
    if (footer) {
      footer = <div className={this.getClassName().footer}>{footer}</div>;
    }
    return footer;
  },

  _getBody(){
    let children = this.buildChildren({content: this.state.content, children: this.props.children});
    if (children) {
      children = <div className={this.getClassName().body}>{children}</div>;
    }
    return children;
  },

  //@@viewOff:componentSpecificHelpers

  //@@viewOn:render
  render() {
    return (
      <div {...this._getMainAttrs()}>
        <div className={this.getClassName().content}>
          {this._getHeader()}
          {this._getBody()}
          {this._getFooter()}
        </div>
        <Backdrop {...this._getBackdropProps()} />
        {this.getDisabledCover()}
      </div>
    );
  }
  //@@viewOff:render
});

export default Popover;



// WEBPACK FOOTER //
// ./bricks/popover.js